/**
 * Утилита для объединения классов CSS
 * Фильтрует falsy значения и объединяет строки
 */
export const cn = (...classes: Array<string | undefined | false | null>) =>
  classes.filter(Boolean).join(" ")
